import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Button, Modal } from 'react-bootstrap';
import { BASE_URL } from './../../../config';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../Styles/FrmStyles.css';

const FrmCrearEquipo = ({ showModal, handleCloseModal, equipo = null, onAddEquipos, onUpdateEquipos }) => {
    const [nombre, setNombre] = useState('');
    const [urlImagen, setImagen] = useState(null);

    const token = localStorage.getItem('token');

    useEffect(() => {
        if (equipo) {
            setNombre(equipo.nombre || '');
            setImagen(equipo.urlImagen || '');
        }
    }, [equipo]);

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImagen(file);
        }
    };

    const createOrUpdateTeam = async () => {
        const formData = new FormData();
        formData.append('nombre', nombre);
        if (urlImagen instanceof File) {
            formData.append('file', urlImagen);
        }

        if (!nombre) {
            toast.error('Debes al menos enviar el nombre del equipo');
            return;
        }

        try {
            if (equipo && equipo.id) {
                const response = await axios.post(`${BASE_URL}equipos/${equipo.id}`, formData, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'multipart/form-data',
                    },
                });
                if (response.status === 200) {
                    onUpdateEquipos(response.data);
                    handleCloseModal();
                    toast.success('Equipo actualizado exitosamente');
                }
            } else {
                const response = await axios.post(`${BASE_URL}equipos`, formData, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'multipart/form-data',
                    },
                });
                if (response.status === 201) {
                    toast.success('Equipo creado exitosamente');
                    onAddEquipos(response.data);
                    handleCloseModal();
                }
            }
        } catch (error) {
            toast.error('Ocurrió un error inesperado, inténtalo de nuevo más tarde');
        }
    };

    return (
        <div>
            <Modal show={showModal} onHide={handleCloseModal}>
                <Modal.Header closeButton>
                    <Modal.Title>{equipo ? 'Actualizar Equipo' : 'Agregar Equipo'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form>
                        <div className="form-group">
                            <label htmlFor="nombre">Nombre del equipo</label>
                            <input
                                type="text"
                                id="nombre"
                                className="form-input"
                                placeholder="Nombre del equipo"
                                value={nombre}
                                onChange={(e) => setNombre(e.target.value)}
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="imagen" className="file-label">Subir imagen del equipo</label>
                            <input
                                type="file"
                                id="imagen"
                                className="form-input file-input"
                                onChange={handleImageChange}
                                accept="image/*"
                            />
                        </div>
                        {urlImagen && (
                            <div className="image-preview-container">
                                <h5>Vista previa:</h5>
                                <img
                                    src={urlImagen instanceof File ? URL.createObjectURL(urlImagen) : urlImagen}  // Manejar archivo o URL
                                    alt="Vista previa"
                                    className="image-preview"
                                />
                            </div>
                        )}
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModal}>
                        Cerrar
                    </Button>
                    <Button variant="primary" onClick={createOrUpdateTeam}>
                        {equipo ? 'Actualizar' : 'Agregar'}
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* <ToastContainer /> */}
        </div>
    );
};

export { FrmCrearEquipo };
